// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606230412/js/" + chunkId + "." + {"44":"694cbafa","225":"7e6618e0","481":"69cc2490","486":"255cdd3a","770":"2e962955"}[chunkId] + ".0.47781273100164745.chunk.js";
};